__turbopack_context__.v({
  "backdrop": "NFk55G_backdrop",
  "canvas": "NFk55G_canvas",
  "diag": "NFk55G_diag",
  "fallback": "NFk55G_fallback",
  "frame-in": "NFk55G_frame-in",
  "world": "NFk55G_world",
});
